import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/api/auth/login',
    method: 'post',
    data
  })
}
export function captcha() {
  return request({
    url: '/api/auth/captcha',
    method: 'get'
  })
}

export function getInfo() {
  return request({
    url: '/api/auth/info',
    method: 'get',
    silent: true
  })
}

export function logout() {
  return request({
    url: '/api/auth/logout',
    method: 'post'
  })
}
